
let ds24cart_initialized: boolean|undefined;

export function _TEST_reset_init_info_bar_initialized() {
    ds24cart_initialized = undefined;
}

export function ds24cart_init_info_bar()
{
    if (typeof ds24cart_initialized == 'undefined')
    {
        ds24cart_initialized = true;

        // disable initital transition
        let extra_class = '';
        let extra_style = '';
        let offset;

        if (typeof window.DS24_INFO_POSITION == 'undefined') {
            window.DS24_INFO_POSITION = 'top';
        }

        if (typeof window.DS24_INFO_STICKY == 'undefined') {
            window.DS24_INFO_STICKY = false;
        }
        switch (window.DS24_INFO_POSITION)
        {
            case 'top':
                // empty
                break;
            case 'bottom':
                extra_class += 'ds24_bottom';
                break;

            default:
                offset = parseInt( '' + window.DS24_INFO_POSITION );
                if (offset > 0 && offset < 10000)
                {
                    extra_style = "top: " + offset + "px;";
                }
        }

        if (window.DS24_INFO_STICKY) {
            extra_class += ' app_cart_sticky';
        }
        else {
            extra_style += 'display: none;';
            extra_class += ' app_cart_closable';
        }

        const addedContainer = document.createElement('div');
        addedContainer.id = 'app_cart_added_container';
        addedContainer.className = extra_class;
        addedContainer.setAttribute('style', extra_style);
        document.body.appendChild(addedContainer);
        
        setTimeout(() => {
            // display it, after initial transitions ready
            addedContainer.style.removeProperty('display');    
        }, 300);
        
    }
}
